import { useTranslation } from '@zurich/common/hooks';
export const useECommunicationProps = () => {
    const { t } = useTranslation();
    const eCommunicationOptions = [
        { label: t('common:yes'), value: true },
        { label: t('common:no'), value: false },
    ];
    return {
        eCommunicationOptions,
        getECommunicationValue: (value) => eCommunicationOptions.find((o) => o.value === value) || null,
    };
};
